module.exports = __webpack_public_path__ + "static/sql-database-ed0565ac33f794c3dc67847466facc97.svg";